import { DataTableDesignTokens } from '@primeuix/themes/types/datatable';

import {
  getColor,
  getFontWeight,
  getRem,
} from '@customer-portal/shared/helpers/theme-utils';

export const gridOverride: DataTableDesignTokens = {
  header: {
    borderColor: 'transparent',
    color: getColor('DarkBlue'),
    background: 'none',
    borderWidth: '0',
    padding: '0',
    sm: { padding: `${getRem(9)} ${getRem(12)}` },
    lg: { padding: `${getRem(18)} ${getRem(24)}` },
  },
  headerCell: {
    background: getColor('Sandstone95'),
    selectedBackground: getColor('WhiteSmoke'),
    borderColor: 'transparent',
    color: getColor('DarkBlue'),
    gap: getRem(9),
    padding: `${getRem(12)} ${getRem(12)}`,
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: getColor('SeaBlue'),
      offset: `-${getRem(1)}`,
      shadow: 'none',
    },
    sm: { padding: `${getRem(9)} ${getRem(12)}` },
    lg: { padding: `${getRem(18)} ${getRem(24)}` },
  },
  columnTitle: {
    fontWeight: getFontWeight('bold'),
  },
  row: {
    background: getColor('UiWhite'),
    hoverBackground: getColor('primary.50'),
    selectedBackground: getColor('primary.100'),
    color: getColor('content.color'),
    hoverColor: getColor('content.color'),
    selectedColor: getColor('content.color'),
    focusRing: {
      width: '{focus.ring.width}',
      style: '{focus.ring.style}',
      color: getColor('SeaBlue'),
      offset: `-${getRem(1)}`,
      shadow: 'none',
    },
  },
  bodyCell: {
    borderColor: 'transparent',
    padding: `${getRem(16)}`,
  },
  footerCell: {
    background: getColor('UiWhite'),
    borderColor: getColor('SeaBlue'),
    color: getColor('SeaBlue'),
    padding: `${getRem(12)} ${getRem(15)}`,
    sm: {
      padding: `${getRem(6)}  ${getRem(9)}`,
    },
    lg: {
      padding: `${getRem(15)} ${getRem(18)}`,
    },
  },
  columnFooter: {
    fontWeight: getFontWeight('bold'),
  },
  footer: {
    background: getColor('UiWhite'),
    borderColor: getColor('SeaBlue'),
    color: getColor('SeaBlue'),
    borderWidth: `0 0  ${getRem(0.06)} 0`,
    padding: `${getRem(12)} ${getRem(15)}`,
    sm: {
      padding: `${getRem(6)} ${getRem(9)}`,
    },
    lg: {
      padding: `${getRem(15)} ${getRem(18)}`,
    },
  },
  sortIcon: {
    color: getColor('DarkBlue'),
    hoverColor: getColor('primary.color'),
    size: getRem(12),
  },
  paginatorTop: {
    borderColor: getColor('SeaBlue'),
    borderWidth: `0 0 ${getRem(1)} 0`,
  },
  paginatorBottom: {
    borderColor: getColor('SeaBlue'),
    borderWidth: `0 ${getRem(1)} 0`,
  },
  colorScheme: {
    light: {
      root: {
        borderColor: getColor('Sandstone95'),
      },
      row: {
        stripedBackground: getColor('WhiteSmoke10'),
      },
      bodyCell: {
        selectedBorderColor: 'transparent',
      },
    },
  },
  filter: {
    overlayPopover: {
      padding: '0',
      gap: '0',
      borderRadius: getRem(10),
    },
    overlaySelect: {
      borderRadius: `${getRem(10)}`,
      shadow: `0 ${getRem(3)} ${getRem(6)} ${getColor('DarkBlack')}`,
    },
  },
};
